import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();
  useSeo(
    "页面不存在 - 97视频",
    "你访问的页面不存在或已经调整，可返回97视频首页继续浏览电影、电视剧与综艺内容。",
  );

  return (
    <SiteLayout>
      <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-heading text-6xl font-black text-background-300 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h1>
        <p className="mt-2 font-label text-[11px] text-foreground-400">{location.pathname}</p>
        <p className="mt-3 max-w-md text-[13px] leading-relaxed text-foreground-600">
          这条链接可能已经失效，或者内容已被调整。回到首页，继续寻找你想看的影视。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line flex h-4 w-4 items-center justify-center" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-[13px] text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-600"
          >
            <i className="ri-search-line flex h-4 w-4 items-center justify-center" />
            搜索影视
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}